import React from "react";
import { SearchBox } from "@quintype/components";
import SearchIcon from "../../atoms/icons/search-icon";
import "./normal-search-box.m.css";

class NormalSearchBox extends React.Component {
  render() {
    return (
      <React.Fragment>
        <div styleName="searchbox-wrapper">
          <SearchIcon className="search-stories-component-icon" height={35} color="#626262" />
          <SearchBox
            className="search-stories-component-form"
            template={DrawForm}
            inputId="searchFormNonMobile"
            inputRef={input => (this.input = input)}
            inputClassName="search-stories-component-form-input"
            formRef={searchForm => (this.searchForm = searchForm)}
            placeholder="Type to search"
          />
        </div>
      </React.Fragment>
    );
  }
}

function DrawForm({ children }) {
  return [
    <label className="search-stories-component__form-label" htmlFor="searchForm" key="1">
      {children}
    </label>
  ];
}

export { NormalSearchBox };
